import {
  Button,
  MenuItem,
  Stack,
  Typography,
  styled,
  Grid,
  Divider,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Layout } from "../dashboard/dashboard";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DataTable from "./BankTransferTable";
import BankTransfersIcon from "@mui/icons-material/Payment";
import CustomDialogue from "../reuseableComp/Modal";
import { CustomField } from "../client";
import { Back } from "../../assets/Svg";
import PrintIcon from "@mui/icons-material/Print";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import Logo from "../../assets/erorex-Logo.png";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Autocomplete from "@mui/material/Autocomplete";
import ReactToPrint from "react-to-print";

import {
  getBanks,
  getData,
  saveData,
  updateDataGeneral,
} from "../../apiservices";
import { toast } from "react-toastify";
import ClientInfo from "../ClientInfo";
export const Btn = styled(Button)({
  minWidth: "126px",
  height: "36px",
  padding: "4px",
  borderRadius: "4px",
  textTransform: "none",
  background: "#FFFFFF",
  color: "#05B905",
  marginRight: 10,
  "&:hover": {
    background: "#F6F6F6",
  },
  "&:active": {
    background: "#FFFFFF",
  },
});
export const Typo = styled(Typography)({
  fontWeight: 700,
  fontSize: "20px",
  color: "#05B905",
});
export const Lay = styled(Stack)({
  // borderRadius: "8px",
  padding: 15,
  border: "1px solid #9F9E9E",
});
const BankTransfer = () => {
  const theme = useTheme();
  const componentRef = useRef();
  const smallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [accountInfo, setAccountInfo] = useState("")
  const [receivedBy, setRecievedBy] = useState("")
  const [state, setState] = useState({
    openModal: false,
    viewBankTransfer: false,
    banksList: [],
    selectedBank: "",
    amount: 0,
    bankTransfers: {},
    bankTransferData: [],
    accNum: "",
    accId: 0,
    currentBalance: 0,
    accountsArr: [],
    accountsArrFrom: [],
    uniBanksArr: [],
    selectedAcc: {},
    check: false,
    updatedData: {},
  });

  const getBanksList = async () => {
    let userData = JSON.parse(localStorage.getItem("user"));
    let obj = {

    };
    let res = await getBanks(obj);
    if (res.success) {
      let arr = [];
      res.data.map((item) => arr.push(item.bank_name));
      const accInfo = res.data && res.data.length > 0 && res.data.filter((x) => x.id == state.bankTransfers.acc_id)[0]
      if (accInfo) {
        setAccountInfo(`${accInfo.account_title} [${accInfo.account_number}]`)
      }
      const arrayWithDuplicates = arr;
      const uniqueArray = [...new Set(arrayWithDuplicates)];
      setState((prev) => ({
        ...prev,
        banksList: res.data,
        uniBanksArr: uniqueArray,
      }));
    }
  };

  useEffect(() => {
    getBankTransfers();
  }, [state.banksList])

  useEffect(() => {
    getBanksList();
  }, [state.bankTransfers])

  // useEffect(() => {
  //   getUsers();
  // }, [state.bankTransfers])

  const getUsers = async () => {
    const data = {
      table: "users"
    }
    const res = await getData(data)
    if (res.success) {
      const user = res.data && res.data.length && res.data.filter((x) => x.id == state.bankTransfers.added_by)[0]
      if (user) {
        setRecievedBy(`${user.fname} ${user.lname}`)
      }
    }
  }

  const getBankTransfers = async () => {
    const data = {
      table: "bank_transfers"
    }
    const res = await getData(data)
    if (res.success) {
      res.data.map((x) => {
        if (x.id.length == 1) {
          x.show_id = `BankTransfer#00${x.id}`
        }
        else if (x.id.length == 2) {
          x.show_id = `BankTransfer#0${x.id}`
        }
        else {
          x.show_id = `BankTransfer#${x.id}`
        }
        if (state.banksList && state.banksList.length) {
          x.bank_to = state.banksList.filter(bank => bank.id === x.acc_id_to)[0].bank_name
          const acc_number_to = state.banksList.filter(bank => bank.id === x.acc_id_to)[0].account_number
          const acc_title_to = state.banksList.filter(bank => bank.id === x.acc_id_to)[0].account_title
          x.acc_to = `${acc_title_to} [${acc_number_to}]`

          x.bank_from = state.banksList.filter(bank => bank.id === x.acc_id_from)[0].bank_name
          const acc_number_from = state.banksList.filter(bank => bank.id === x.acc_id_from)[0].account_number
          const acc_title_from = state.banksList.filter(bank => bank.id === x.acc_id_from)[0].account_title
          x.acc_from = `${acc_title_from} [${acc_number_from}]`
        }
      })
      setState((prev) => ({
        ...prev,
        bankTransferData: res.data.sort((a, b) => b.id - a.id)
      }));
    }
    else {
      setState((prev) => ({
        ...prev,
        bankTransferData: [],
      }));
    }
  };
  const handleModal = (data = "") => {
    if (data.amount) {
      setState((prev) => ({ ...prev, check: true }));
    }
    const sBankTo = state.banksList && state.banksList.length > 0 && state.banksList.filter((x) => x.id == data.acc_id_to)[0] && state.banksList.filter((x) => x.id == data.acc_id_to)[0].bank_name ? state.banksList.filter((x) => x.id == data.acc_id_to)[0].bank_name : ""
    const sBankFrom = state.banksList && state.banksList.length > 0 && state.banksList.filter((x) => x.id == data.acc_id_from)[0] && state.banksList.filter((x) => x.id == data.acc_id_from)[0].bank_name ? state.banksList.filter((x) => x.id == data.acc_id_from)[0].bank_name : ""
    setState((prev) => ({
      ...prev,
      openModal: !prev.openModal,
      selectedBank: sBankTo,
      selectedAcc: data?.acc_id_to && `${data?.acc_id_to}`,
      selectedBankFrom: sBankFrom,
      selectedAccFrom: data?.acc_id_from && `${data?.acc_id_from}`,
      updatedData: data,
      amount: data?.amount,
    }));
    let filtered = state.banksList.filter(
      (item) => item.bank_name === sBankTo
    );
    setState((prev) => ({ ...prev, accountsArr: filtered }));
    let filtered_from = state.banksList.filter(
      (item) => item.bank_name === sBankFrom
    );
    setState((prev) => ({ ...prev, accountsArrFrom: filtered_from }));
  };

  const view = async (data = "") => {
    // console.log("data", data)
    setState((prev) => ({
      ...prev,
      viewBankTransfer: !prev.viewBankTransfer,
    }));
    if (data.id) {
      setState((prev) => ({
        ...prev,
        bankTransfers: data,
      }));
    }
  };

  const handleChange = (e) => {
    let { name } = e.target;
    let { value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
    if (name === "selectedBank") {
      let arr = [];
      let filtered = state.banksList.filter((item) => item.bank_name === value);
      filtered.map((item) => arr.push(item.address));
      setState((prev) => ({ ...prev, accountsArr: filtered }));
    }
    if (name === "selectedAcc") {
      setState((prev) => ({ ...prev, accId: value }))
    }

    if (name === "selectedBankFrom") {
      let arr = [];
      let filtered = state.banksList.filter((item) => item.bank_name === value);
      filtered.map((item) => arr.push(item.address));
      setState((prev) => ({ ...prev, accountsArrFrom: filtered }));
    }
    if (name === "selectedAccFrom") {
      setState((prev) => ({ ...prev, accIdFrom: value }))
    }
  };

  const saveBankTransfer = async () => {
    if (!state.accId || !state.accIdFrom || !state.amount) {
      toast.error("Both accounts and amount must be selected...!")
      return
    }
    let userData = JSON.parse(localStorage.getItem("user"));
    if (state.check) {
      let obj = {
        table: "bank_transfers",
        data: {
          date: new Date().toISOString().split('T')[0],
          acc_id_to: state.accId,
          acc_id_from: state.accIdFrom,
          amount: state.amount,
          added_by: userData.id,
        },
        filters: [
          {
            column_name: "id",
            operation: "=",
            value: state.updatedData.id
          }
        ]
      };
      let res = await updateDataGeneral(obj);
      if (res.success) {
        toast.success("BankTransfer updated successfully");
        handleModal();
        getBankTransfers();
      }
      else {
        console.log(res)
        toast.error("Something went wrong");
      }
    } else {
      let obj = {
        table: "bank_transfers",
        data: {
          date: new Date().toISOString().split('T')[0],
          acc_id_to: state.accId,
          acc_id_from: state.accIdFrom,
          amount: state.amount,
          added_by: userData.id,
        }
      };
      let res = await saveData(obj);
      if (res.success) {
        handleModal();
        await getBankTransfers();
        toast.success("Bank transfer saved successfully");
      }
      else {
        console.log(res)
        toast.error("Something went wrong");
      }
    }
  }
  const updateData = (data) => {
    setState((prev) => ({ ...prev, bankTransferData: data }));
  };
  const ComponentToPrint = React.forwardRef((props, ref) => (
    <Stack
      width={"98%"}
      sx={{
        padding: 1,
      }}
      ref={ref}
      id="content-to-print">
      <ClientInfo />
      <Stack justifyContent={"center"} alignItems={"center"}>
        <Typography sx={{ fontSize: "24px", fontWeight: "bold" }}>
          Bank Transfers
        </Typography>
      </Stack>
      <Grid
        container
        style={{ marginBottom: "10px", marginTop: 8 }}
        spacing={1}>
        <Grid item lg={3} md={3} sm={3} xs={3}>
          <Stack
            sx={{
              backgroundColor: "#05B905",
              color: "#000",
              padding: 0.5,
              borderRadius: "10px",
            }}
            alignItems={"left"}>
            <Typography sx={{ fontWeight: "16px", mx: 2 }}>
              {" "}
              Received By:
            </Typography>
          </Stack>
          <Stack alignItems={"start"}>
            <Typography sx={{ marginTop: 2, mx: 2 }}>
              {receivedBy}
            </Typography>
          </Stack>
        </Grid>

        <Grid item lg={3} md={3} sm={3} xs={3}>
          <Stack
            sx={{
              backgroundColor: "#05B905",
              color: "#000",
              padding: 0.5,
              borderRadius: "10px",
            }}
            alignItems={"left"}>
            <Typography sx={{ fontWeight: "16px", mx: 2 }}> Payer:</Typography>
          </Stack>
          <Stack alignItems={"start"}>
            <Typography sx={{ marginTop: 2, mx: 2 }}>
              {state.clientData && state.clientData.length && state.clientData.filter((x) => x.id == state.bankTransfers.supplier_id)[0].name}
            </Typography>
          </Stack>
        </Grid>
        <Grid item lg={3} md={3} sm={3} xs={3}>
          <Stack
            sx={{
              backgroundColor: "#05B905",
              color: "#000",
              padding: 0.5,
              borderRadius: "10px",
            }}
            alignItems={"left"}>
            <Typography sx={{ fontWeight: "16px", mx: 2 }}>
              Bank Transfer #
            </Typography>
          </Stack>

          <Stack alignItems={"start"}>
            <Typography sx={{ marginTop: 2, mx: 2 }}>
              {state.bankTransfers && (state.bankTransfers.id.length == 1 ? "BankTransfer#00" : state.bankTransfers.id.length == 2 ? "BankTransfer#0" : "BankTransfer#")}
              {state.bankTransfers.id}
            </Typography>
          </Stack>
        </Grid>
        <Grid item lg={3} md={3} sm={3} xs={3}>
          <Stack
            sx={{
              backgroundColor: "#05B905",
              color: "#000",
              padding: 0.5,
              borderRadius: "10px",
            }}
            alignItems={"left"}>
            <Typography sx={{ fontWeight: "16px", mx: 2 }}>Date</Typography>
          </Stack>
          <Stack alignItems={"start"}>
            <Typography sx={{ marginTop: 2, mx: 2 }}>
              {" "}
              {state.bankTransfers.date}
            </Typography>
          </Stack>
        </Grid>
      </Grid>

      <Lay
        direction={"row"}
        spacing={2}
        justifyContent={"space-between"}
        sx={{ paddingLeft: 2, paddingRight: 2, marginTop: 4 }}
        alignItems={"center"}>
        <Typography>Transaction Mode:</Typography>
        <Typography>
          {state.bankTransfers.transaction_mode === "Bank"
            ? state.banksList && state.banksList.length > 0 && state.banksList.filter((x) => x.id == state.bankTransfers.acc_id)[0] && state.banksList.filter((x) => x.id == state.bankTransfers.acc_id)[0].bank_name ? state.banksList.filter((x) => x.id == state.bankTransfers.acc_id)[0].bank_name : ""
            : state.bankTransfers.transaction_mode}
        </Typography>
      </Lay>
      {state.bankTransfers.transaction_mode === "Bank" && (
        <Lay
          direction={"row"}
          spacing={2}
          justifyContent={"space-between"}
          sx={{ paddingLeft: 2, paddingRight: 2 }}
          alignItems={"center"}>
          <Typography>Account Title & Number :</Typography>
          <Typography>{accountInfo}</Typography>
        </Lay>
      )}
      <Lay
        direction={"row"}
        justifyContent={"space-between"}
        sx={{ paddingLeft: 2, paddingRight: 2 }}
        alignItems={"center"}>
        <Typography>Amount:</Typography>
        <Typography>{state.bankTransfers.amount}</Typography>
      </Lay>
      <Lay
        direction={"row"}
        justifyContent={"space-between"}
        sx={{ paddingLeft: 2, paddingRight: 2 }}
        alignItems={"center"}>
        <Typography>Current Balance:</Typography>
        <Typography>{state.currentBalance}</Typography>
      </Lay>
    </Stack>
  ));
  const handleCheck = () => {
    setState((prev) => ({ ...prev, check: !prev.check }));
  };

  return (
    <Stack sx={{ paddingLeft: 2, paddingRight: 2 }}>
      <>
        {!state.viewBankTransfer ? (
          <>
            <Layout
              justifyContent="space-between"
              alignItems={"center"}
              direction={"row"}>
              <Typography
                sx={{
                  color: "#000",
                  fontSize: "24px",
                  fontWeight: 700,
                }}></Typography>
              <Typography
                sx={{ color: "#000", fontSize: "24px", fontWeight: 700 }}>
                Bank Transfers
              </Typography>
              <Btn onClick={() => {
                setState((prev) => ({ ...prev, check: false }));
                handleModal()
              }}>
                <AddCircleIcon fontSize="small" sx={{ mx: 1 }} /> Add new
                Bank Transfer
              </Btn>
            </Layout>
            <Stack sx={{ padding: "20px" }}>
              <DataTable
                editBankTransfer={handleModal}
                view={view}
                data={state.bankTransferData}
                getData={getBankTransfers}
                handleCheck={handleCheck}
                clientData={state.clientData}
              />
            </Stack>
          </>
        ) : (
          <Stack justifyContent={"center"} alignItems={"center"}>
            <Layout
              justifyContent="space-between"
              alignItems={"center"}
              direction={"row"}>
              <Typography
                sx={{
                  color: "#000",
                  fontSize: "24px",
                  fontWeight: 700,
                  padding: 1,
                }}>
                {!smallScreen && "Bank Transfer Details"}
              </Typography>
              <Stack direction={"row"}>
                {/* <Btn onClick={view}>
                  <AppReg fontSize="small" sx={{ mx: 1 }} /> View All BankTransfers
                </Btn> */}

                <ReactToPrint
                  trigger={() => (
                    <Btn>
                      <PrintIcon fontSize="small" sx={{ mx: 1 }} />{" "}
                      {!smallScreen && "Print"}
                    </Btn>
                  )}
                  content={() => componentRef.current}
                />

                <Btn onClick={view}>
                  <Back sx={{ mx: 1 }} />
                  {!smallScreen && "Back"}
                </Btn>
              </Stack>
            </Layout>
            <ComponentToPrint ref={componentRef} />
          </Stack>
        )}
      </>
      <CustomDialogue
        open={state.openModal}
        handleClose={handleModal}
        header={
          <Stack justifyContent={"center"} alignItems={"center"}>
            <BankTransfersIcon sx={{ color: "#05B905" }} fontSize="large" />
            <Typo>Add New Bank Transfer</Typo>
          </Stack>
        }
        content={
          <Stack sx={{ padding: 2 }}>

            <CustomField
              fullWidth
              id="outlined-select-currency"
              select
              label="Bank Name (From)"
              name="selectedBankFrom"
              value={state.selectedBankFrom}
              onChange={handleChange}
              sx={{ mb: 2 }}>
              {state.uniBanksArr.map((option) => (
                <MenuItem key={option} value={option}>
                  {`${option}`}
                </MenuItem>
              ))}
            </CustomField>
            <CustomField
              fullWidth
              id="outlined-select-currency"
              select
              label="Select Account (From)"
              name="selectedAccFrom"
              value={state.selectedAccFrom}
              onChange={handleChange}
              sx={{ mb: 2 }}>
              {state.accountsArrFrom.map((option, id) => (
                <MenuItem
                  key={option.account_number}
                  value={option.id}>
                  {`${option.account_title} [${option.account_number}]`}
                </MenuItem>
              ))}
            </CustomField>
            <hr />

            <CustomField
              fullWidth
              id="outlined-select-currency"
              select
              label="Bank Name (To)"
              name="selectedBank"
              value={state.selectedBank}
              onChange={handleChange}
              sx={{ mb: 2 }}>
              {state.uniBanksArr.map((option) => (
                <MenuItem key={option} value={option}>
                  {`${option}`}
                </MenuItem>
              ))}
            </CustomField>
            <CustomField
              fullWidth
              id="outlined-select-currency"
              select
              label="Select Account (To)"
              name="selectedAcc"
              value={state.selectedAcc}
              onChange={handleChange}
              sx={{ mb: 2 }}>
              {state.accountsArr.map((option, id) => (
                <MenuItem
                  key={option.account_number}
                  value={option.id}>
                  {`${option.account_title} [${option.account_number}]`}
                </MenuItem>
              ))}
            </CustomField>
            <hr />

            <CustomField
              fullWidth
              id="outlined-select-currency"
              label="Enter Amount"
              name="amount"
              value={state.amount}
              onChange={handleChange}
              sx={{ mb: 2 }}
            />
            <Stack spacing={3} direction={"row"} sx={{ mt: 2 }}>
              <Button
                size="small"
                onClick={saveBankTransfer}
                sx={{
                  width: "250px",
                  textTransform: "none",
                  background: "#05B905",
                  color: "#000",
                  "&:hover": {
                    background: "#61D140",
                  },
                }}>
                {state.check ? "update bankTransfer" : " save bankTransfer"}
              </Button>
              <Button
                onClick={handleModal}
                size="small"
                sx={{
                  background: "#FFF",
                  width: "250px",
                  textTransform: "none",

                  color: "#9F9E9E",
                  "&:hover": {
                    background: "#EFEFEF",
                  },
                }}>
                Cancel
              </Button>
            </Stack>
          </Stack>
        }
      />
    </Stack>
  );
};

export default BankTransfer;
